import {
    AUTHORIZATION_LOADING,
    AUTHORIZATION_SUCCESS,
    AUTHORIZATION_FAILED,
    ARN_AUTHORIZATION_LOADING,
    ARN_AUTHORIZATION_SUCCESS,
    ARN_AUTHORIZATION_FAILED,
  } from "../Constants/authorizationConstants";
  
  export const authorizationReducer = (
    state = { authorizationData: [] },
    action
  ) => {
    switch (action.type) {
      case AUTHORIZATION_LOADING:
        return { loading: true, authorizationData: [] };
      case AUTHORIZATION_SUCCESS:
        return { loading: false, authorizationData: action.payload };
      case AUTHORIZATION_FAILED:
        return { loading: false, error: action.authorizationData };
      default:
        return state;
    }
  };

  export const arnAuthorizationReducer = (
    state = { arnAuthorizationData: [] },
    action
  ) => {
    switch (action.type) {
      case ARN_AUTHORIZATION_LOADING:
        return { loading: true, arnAuthorizationData: [] };
      case ARN_AUTHORIZATION_SUCCESS:
        return { loading: false, arnAuthorizationData: action.payload };
      case ARN_AUTHORIZATION_FAILED:
        return { loading: false, error: action.arnAuthorizationData };
      default:
        return state;
    }
  };
  